
export const augmentErrorTryAgain = (text, error) => {
  if (error?.response?.status === 503)
    return text + " Please try again later." 
  else
    return text
};
